import { useState } from 'react';
import useFetch from '../hooks/useFetch'
import { objectToQueryString } from '../utils';
import { apiWrapper } from './dataHookUtils'

export default () => {
  const [isLoading, setIsLoading] = useState(true)
  const [flights, setFlights] = useState([])

  const fetch = useFetch()

  const postHeaders = { "Content-Type": "application/json" }

  const fetchFlights = async (filters = {}) => {
    try {
      setIsLoading(true);
      const response = await fetch(`events/event/flights?${objectToQueryString(filters)}`, { method: 'GET' })
      const jsonData = await response.json()
      if (jsonData.error) {
        setFlights([])
      } else {
        setFlights(jsonData)
      }
     setIsLoading(false)
    } catch (e) {
      console.log(e)
      setFlights([])
      setIsLoading(false)
    }
  }

  const addNewFlight = async (flightData) => {
    return apiWrapper({
      fetch,
      url: `events/event/flight/new`,
      options: {
        method: 'POST', 
        headers: postHeaders,
        body: JSON.stringify({ data: flightData })
      }
    });
  }

  const updateFlight = async (flightData) => {
    return apiWrapper({
      fetch,
      url: `events/event/flight/update`,
      options: {
        method: 'POST', 
        headers: postHeaders,
        body: JSON.stringify({ data: flightData })
      }
    });
  }

  const deleteFlight = async (flightData) => {
    return apiWrapper({
      fetch,
      url: `events/event/flight/delete`,
      options: {
        method: 'POST', 
        headers: postHeaders,
        body: JSON.stringify({ data: flightData })
      }
    });
  }

  return {
    isLoading,
    flights,
    fetchFlights,
    addNewFlight,
    updateFlight,
    deleteFlight
  }
}